import { EmailRecipientList } from "./EmailRecipientList";
export default EmailRecipientList;
export * from "./EmailRecipientList";
